import { Create, SimpleForm, useNotify, useStore } from "react-admin";
import CyclicExamForm from "./CyclicExamForm";
import { CYCLIC_STORE_KEY } from "./List";

import { errorMessages } from "app";
import useConflictErrorModal from "server/components/Modals/useConflictErrorModal";

import CyclicExamFormTopToolbar from "./CyclicExamFormTopToolbar";

export const handleTransform = filters => data => {
  const commissions = data.commissions || [];
  const professors = commissions.flatMap((commission, commissionIndex) => {
    const commissionNumber = commission.commissionNumber || commissionIndex + 1;
    return (commission.professors || []).map(professor => ({
      professorEmployeeId: professor.professorEmployeeId,
      role: professor.role,
      commissionNumber,
    }));
  });
  const { commissions: _, ...rest } = data;
  const payload = {
    ...rest,
    cyclicStreamId: filters.cyclicStreamId,
    professors,
  };
  return { ...payload };
};
const CreateCyclicExams = () => {
  const [filters] = useStore(CYCLIC_STORE_KEY);

  const { handleConflictError, ConflictErrorDialog } = useConflictErrorModal();
  const notify = useNotify();

  return (
    <>
      <CyclicExamFormTopToolbar cyclicStreamId={filters.cyclicStreamId} />
      <Create
        transform={handleTransform(filters)}
        onError={e => {
          const errorMessage = e.message || errorMessages[e.errorCode];
          notify(errorMessage, { type: "error" });
          handleConflictError(e);
        }}
        title="Създаване на цикличен изпит"
      >
        <SimpleForm>
          <CyclicExamForm filters={filters} />
        </SimpleForm>
      </Create>
      <ConflictErrorDialog />
    </>
  );
};
export default CreateCyclicExams;
